import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem } from '@mui/material';
// routes
import { PATHS_SOLVER, PATH_AUTH, } from '../../../routes/paths';
// auth
import { useSessionContext } from '../../../contexts/session/useSessionContext';
// components
import { CustomAvatar } from '../../../components/custom-avatar';
import { useSnackbar } from '../../../components/snackbar';
import MenuPopover from '../../../components/menu-popover';
import { IconButtonAnimate } from '../../../components/animate';
import { usePLRecordContext } from 'contexts/plrecord/usePLRecordContext';
import PolicyAgreementDialog from 'components/policy-agreement/PolicyAgreementDialog';

// ----------------------------------------------------------------------



// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();
  const session = useSessionContext();

  const { account, logout } = useSessionContext();
  const { reset, } = usePLRecordContext();

  const { enqueueSnackbar } = useSnackbar();

  const [openPolicyDialog, setOpenPolicyDialog] = useState(false);
  
  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleLogout = async () => {
    try {
      logout();
      reset();
      navigate(PATH_AUTH.login, { replace: true });
      handleClosePopover();
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout!', { variant: 'error' });
    }
  };

  const handleClickItem = (path: string) => {
    handleClosePopover();
    navigate(path);
  };

  const initials = (s : string): string => {
    return s.split(' ').map((v) => {
      if (v.length >= 1) {
        return v[0].toUpperCase()
      }
      return '';
    }).join('');
  }

  const OPTIONS = [
    {
      label: 'Home',
      linkTo: '/',
    },
    {
      label: 'Profile',
      linkTo: PATHS_SOLVER.profile,
    },
    ...(session.appConfig.appType === 'COMMERCIAL' ? [{
      label: 'Help',
      linkTo: PATHS_SOLVER.help,
    }] : []),
    // {
    //   label: 'Settings',
    //   linkTo: PATH_APP.user.settings,
    // },
  ];

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          p: 0,
          ...(openPopover && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <CustomAvatar color='primary' sx={{ fontSize: 'small', }}>
          {initials(account.username || '')}
        </CustomAvatar>
      </IconButtonAnimate>

      <MenuPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 200, p: 0 }}>
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {account.username}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {account.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        {session.appConfig.securitySettings.usePolicyAgreement && (
          <>
            <Divider sx={{ borderStyle: 'dashed' }} />

            <MenuItem onClick={() => setOpenPolicyDialog(true)} sx={{ m: 1 }}>
              Terms of Service
            </MenuItem>
          </>
        )}

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </MenuPopover>

      {session.appConfig.securitySettings.usePolicyAgreement && session.appConfig.securitySettings.policyAgreement && (
        <PolicyAgreementDialog
          open={openPolicyDialog}
          onClose={() => setOpenPolicyDialog(false)}
        />
      )}
      
    </>
  );
}
